import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, filter, Subject } from 'rxjs';
import { Engagements } from '../../../API';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public isSidebarCollapsed = false;
  public activeEngagementSubject$ = new BehaviorSubject<Engagements | null>(null);
  public activeEngagement$ = this.activeEngagementSubject$.asObservable().pipe(filter((val) => !!val));
  public dcrHubLink = environment.dcr_hub_link;
  public showEngagements = true;
  public ENV = environment.serviceEnv;
  private dataConnectionHeaderSignal = signal('Create Data Connection');
  private isEngagementActiveSignal = signal(true);
  private domain = environment.domain;
  private triggerEngagementSubject = new Subject<void>();
  public triggerEngagement$ = this.triggerEngagementSubject.asObservable();

  refreshEngagementList() {
    this.triggerEngagementSubject.next();
  }

  get dataConnectionHeader() {
    return this.dataConnectionHeaderSignal();
  }

  set dataConnectionHeader(header: string) {
    this.dataConnectionHeaderSignal.set(header);
  }

  get domainUrl(): string {
    return this.domain;
  }

  get isEngagementActive() {
    return this.isEngagementActiveSignal();
  }

  set isEngagementActive(active: boolean) {
    this.isEngagementActiveSignal.set(active);
  }
}
